import { render, staticRenderFns } from "./virusInsulate.vue?vue&type=template&id=fb1bed68&scoped=true&"
import script from "./virusInsulate.vue?vue&type=script&lang=js&"
export * from "./virusInsulate.vue?vue&type=script&lang=js&"
import style0 from "./virusInsulate.vue?vue&type=style&index=0&id=fb1bed68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1bed68",
  null
  
)

export default component.exports